<template>
  <div class="login-wrapper" style="overflow-y: scroll;">
    <a href="https://www.complyon.com/" class="mt-3 ml-3 white-logo">
      <img src="@/assets/complyon-white.png" style="width: auto; height: 35px;" class="mt-3">
    </a>
    <a href="https://www.complyon.com/" class="mt-3 ml-3 black-logo">
      <img src="@/assets/complyon_logo.svg" style="width: auto; height: 35px;" class="mt-3">
    </a>
    <span class="login-credits">Photo by <a href="https://www.tiredofbeingmild.com/">@tiredofbeingmild</a></span>

    <div class="login">
      <div class="login-block p-3">
        <h1 class="text-bold mb-3">
          {{ $t('login.title') }}
        </h1>
        <div v-if="!showForgotPassword">
          <b-alert v-if="form.wrongCredentials"
                   show
                   variant="danger"
                   qid="login-form-error"
          >
            {{ form.errorMessage }}
          </b-alert>
          <b-alert v-if="successMessage && successMessage.length"
                   show
                   variant="info"
                   qid="login-form-success"
          >
            {{ successMessage }}
          </b-alert>
          <b-alert v-if="form.verify"
                   show
                   variant="danger"
                   qid="login-form-error"
          >
            {{ form.errorMessage }}
            <span @click="resendEmail()" class="text-success cursor-pointer">{{ $t('login.resend_email') }}</span>
          </b-alert>
          <b-alert v-if="showTokenExpired"
                   show
                   variant="danger"
                   qid="login-form-error"
          >
            {{ tokenExpiredMessage }}
            <span @click="resendEmail()" class="text-success cursor-pointer">{{ $t('login.resend_email') }}</span>
          </b-alert>
          <b-alert v-if="showResendEmailSuccessMessage" show variant="info">
            {{ $t('resend_email.success_message') }}
          </b-alert>

          <div class="row">
            <div class="col-sm-6 mt-3 mb-3 microsoft-button">
              <button
                 class="btn btn-block btn-secondary pt-3 pb-3"
                 qid="login-microsoft-button"
                 @click="handleMicrosoftLogin"
              >
                <font-awesome-icon :icon="['fab', 'microsoft']"/>
                {{ $t('login.microsoft_button') }}
              </button>
            </div>
            <div class="col-sm-6 mt-3 mb-3 google-button">
              <button
                  class="btn btn-block btn-secondary pt-3 pb-3"
                  qid="login-google-button"
                  @click="handleGoogleLogin"
              >
                <font-awesome-icon :icon="['fab', 'google']"/>
                {{ $t('login.google_button') }}
              </button>
            </div>
          </div>

          <div style="width: 100%; height: 15px; border-bottom: 1px solid black; text-align: center; margin-bottom: 30px;">
            <span style="font-size: 20px; background-color: white; padding: 0 10px;">
              <span style="text-transform: uppercase;">{{ $t('system.or') }}</span>
            </span>
          </div>

          <b-form @submit="onSubmit" qid="login-form">
            <div class="form-container">
              <b-form-group class="mb-4">
                <label>{{ $t('login.email_label') }}</label>
                <b-form-input
                  qid="input-login-email"
                  type="email"
                  v-model="form.email"
                  required
                  :placeholder="$t('login.email_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group class="mb-5">
                <label>{{ $t('login.password_label') }}</label>
                <b-form-input
                  type="password"
                  qid="input-login-password"
                  v-model="form.password"
                  required
                  :placeholder="$t('login.password_placeholder')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="">
              <div class="md-3">
                <b-button type="submit"
                          variant="success"
                          :disabled="buttonDisabled"
                          class="btn-block pb-3 pt-3"
                          qid="button-submit-login"
                >
                  {{ $t('login.button') }}
                </b-button>
              </div>

              <div class="md-9" style="text-align: right; margin-top: 5px;">
                <a href="#"
                   @click="showForgotPassword = true; form.wrongCredentials = false;"
                   data-qid="show-forgot-password-link"
                >
                  {{ $t('forgot_password.link') }}
                </a>
              </div>

            </div>
          </b-form>
        </div>

        <div v-if="showForgotPassword">
          <h5>
            {{ $t('forgot_password.title') }}
          </h5>
          <b-alert v-if="forgotPassForm.wrongCredentials"
                   show
                   variant="danger"
                   qid="request-pass-error"
          >
            {{ forgotPassForm.errorMessage }}
          </b-alert>
          <b-alert v-if="showForgotPasswordSuccessMessage" show variant="info">
            {{ $t('forgot_password.success_message') }}
          </b-alert>
          <b-form @submit="SubmitForgotPass">
            <div class="form-container">
              <b-form-group>
                <b-form-input
                  qid="input-requestPass-email"
                  type="email"
                  v-model="forgotPassForm.email"
                  required
                  :placeholder="$t('forgot_password.email_placeholder')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="row">
              <div class="col-md forgot-password-container">
                <a href="#"
                   @click="showForgotPassword = false"
                   class="float-left"
                   data-qid="go-to-login-link"
                 >
                  {{ $t('forgot_password.login_link') }}
                </a>
              </div>
              <div class="col-md-5">
                <b-button type="submit"
                          variant="success"
                          :disabled="buttonDisabled"
                          class="btn-block"
                          qid="forgot-password-button"
                >
                  {{ $t('forgot_password.button') }}
                </b-button>
              </div>
            </div>
          </b-form>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import piincHttp from '@/util/configureAxios.js'

export default {
  components: {
  },
  data: function() {
    return {
      form: {
        email: '',
        password: '',
        submitted: false,
        wrongCredentials: false,
        errorMessage: '',
        verify: 0
      },
      forgotPassForm: {
        email: '',
        errorMessage: ''
      },
      showForgotPassword: false,
      showForgotPasswordSuccessMessage: false,
      buttonDisabled: false,
      showResendEmailSuccessMessage: false,
      showTokenExpired: false,
      tokenExpiredMessage: '',
      successMessage: ''
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getHistoryPage() {
      return this.$store.state.historyPage
    }
  },
  methods: {
    redirectOnHome(user) {
      if (user.isAdmin) {
        window.location.href = '/administration';
      } else {
        window.location.href = '/';
      }
    },
    /*goToRegister() {
      this.$router.push({name: 'register', params: {}})
    },*/
    SubmitForgotPass(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      let self = this;
      evt.preventDefault();

      piincHttp.post('password/email', this.forgotPassForm).then(function() {
        self.showForgotPasswordSuccessMessage = true;
        self.forgotPassForm.wrongCredentials = false;
        self.buttonDisabled = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.forgotPassForm.wrongCredentials = true;
          self.forgotPassForm.errorMessage = error.data.message;
        }
      })
    },
    resendEmail() {
      // Keep the reference in a variable
      let self = this;

      self.showTokenExpired = false;
      self.successMessage = '';

      piincHttp.post('/email/resend/'+this.form.email, this.forgotPassForm).then(function() {
        self.showResendEmailSuccessMessage = true;
        self.form.verify = false;
      }, function(error) {
        if (error.status !== 200) {
          self.form.verify = true;
          self.form.errorMessage = error.data.message;
        }
      })
    },
    onSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      let self = this;
      evt.preventDefault();

      self.showResendEmailSuccessMessage = false;
      self.showTokenExpired = false;
      self.successMessage = '';

      piincHttp.post('login', this.form).then(function(response) {
        localStorage.setItem('token', response.data.token);
        self.$store.commit('storeUser', response.data.user);
        self.buttonDisabled = false;
        piincHttp.defaults.headers.common['Authorization'] = localStorage.getItem('token');

        if (self.getHistoryPage && self.getHistoryPage !== '') {
          window.location.href = self.getHistoryPage;
        } else {
          self.redirectOnHome(response.data.user)
        }
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.form.errorMessage = error.data.message;
          if(error.data.message === 'Please verified your account.'){
            self.form.verify = true;
          }else{
            self.form.wrongCredentials = true;
          }
          if (error.status === 429) {
            // TODO: This needs to cover all errors from the array
            self.form.errorMessage = error.data.errors.email[0];
          }
        }
      })
    },
    handleMicrosoftLogin() {
      window.location.href = '/api/auth/azure';
    },
    handleGoogleLogin() {
      window.location.href = '/api/auth/google';
    }
  },
  // Lifecycle hooks
  created() {
    if (this.$route.params.error) {
      this.form.wrongCredentials = true;
      this.form.errorMessage = this.$t('login.error_message')
    }

    if (this.$route.params.success) {
      this.successMessage = this.$t('login.success_message')
    }

    if (this.$route.params.expired) {
      this.showTokenExpired = true;
      this.tokenExpiredMessage = this.$t('login.token_expired_message')
    }

    if (this.$route.query.allowed && this.$route.query.allowed === 'google') {
      this.form.wrongCredentials = true;
      this.form.errorMessage = this.$t('login.error_message_google')
    }

    if (this.$route.query.allowed && this.$route.query.allowed === 'microsoft') {
      this.form.wrongCredentials = true;
      this.form.errorMessage = this.$t('login.error_message_microsoft')
    }


    if (this.$route.query.reset && this.$route.query.reset === 'true') {
      this.showForgotPassword = true;
    }
  }
}
</script>
